import React, { useState, useRef } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

export default function MultiplyBy11StepByStep() {
  const [number, setNumber] = useState('');
  const [digits, setDigits] = useState([]);
  const [firstDigitInput, setFirstDigitInput] = useState('');
  const [sumInput, setSumInput] = useState('');
  const [lastDigitInput, setLastDigitInput] = useState('');
  const [finalInput, setFinalInput] = useState('');
  const [feedback, setFeedback] = useState('');
  const [showSteps, setShowSteps] = useState(false);

  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  const startGame = () => {
    if (!/^\d{2,3}$/.test(number)) {
      alert('Please enter a 2 or 3 digit number!');
      return;
    }
    setDigits(number.split('').map(Number));
    setFirstDigitInput('');
    setSumInput('');
    setLastDigitInput('');
    setFinalInput('');
    setFeedback('');
    setShowSteps(true);
  };

  const checkAnswers = () => {
    const firstDigit = digits[0];
    const lastDigit = digits[digits.length - 1];
    const sums = [];
    for (let i = 0; i < digits.length - 1; i++) {
      sums.push(digits[i] + digits[i + 1]);
    }
    const expectedFirst = firstDigit;
    const expectedMiddle = sums.map(s => s).join('');
    const expectedLast = lastDigit;
    const expectedFinal = calculate11(number);

    const firstCorrect = parseInt(firstDigitInput) === expectedFirst;
    const sumCorrect = sumInput === expectedMiddle;
    const lastCorrect = parseInt(lastDigitInput) === expectedLast;
    const finalCorrect = parseInt(finalInput) === expectedFinal;

    if (firstCorrect && sumCorrect && lastCorrect && finalCorrect) {
      setFeedback(`🎉 Perfect! ${number} × 11 = ${expectedFinal}`);
       const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);     
      correctSound.current.play();

      // Refresh the page after 1 second
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      let issues = [];
      if (!firstCorrect) issues.push("First digit");
      if (!sumCorrect) issues.push("Middle sum");
      if (!lastCorrect) issues.push("Last digit");
      if (!finalCorrect) issues.push("Final answer");
      setFeedback(`❌ Oops: Check ${issues.join(', ')}`);
      wrongSound.current.play();
    }
  };

  const calculate11 = (numStr) => {
    const digs = numStr.split('').map(Number);
    const res = [digs[0]];
    for (let i = 0; i < digs.length - 1; i++) {
      res.push(digs[i] + digs[i + 1]);
    }
    res.push(digs[digs.length - 1]);
    for (let i = res.length - 1; i > 0; i--) {
      if (res[i] >= 10) {
        res[i] -= 10;
        res[i - 1] += 1;
      }
    }
    return Number(res.join(''));
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.h1}>🧙 Multiply by 11 — Step-by-Step</h1>

        {/* Animated Cartoon Character Pointing Down */}
        <img
          src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExeXN1eW91Y3FnMjZzM3l5c2Q2ZG91bjZmbWx5NjNoa3M2cXZ6azNqZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/z835RsRqQHOlC4rsBr/giphy.gif"
          alt="Cartoon hand pointing down"
          style={styles.cartoon}
        />

        <p>Enter a 2 or 3 digit number:</p>
        <input
          type="number"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          style={styles.input}
        />
        <br />
        <button onClick={startGame} style={styles.button}>Start</button>

        {showSteps && (
          <div style={styles.stepBox}>
            <p>1️⃣ First digit:</p>
            <input
              value={firstDigitInput}
              onChange={(e) => setFirstDigitInput(e.target.value)}
              style={styles.input}
            />

            <p>2️⃣ Sum(s) of digits:</p>
            <input
              value={sumInput}
              onChange={(e) => setSumInput(e.target.value)}
              style={styles.input}
            />

            <p>3️⃣ Last digit:</p>
            <input
              value={lastDigitInput}
              onChange={(e) => setLastDigitInput(e.target.value)}
              style={styles.input}
            />

            <p>4️⃣ Final answer:</p>
            <input
              value={finalInput}
              onChange={(e) => setFinalInput(e.target.value)}
              style={styles.input}
            />

            <br />
            <button onClick={checkAnswers} style={styles.button}>Check Answer</button>

            <p style={{
              ...styles.feedback,
              color: feedback.includes('Perfect') ? 'green' : 'red'
            }}>{feedback}</p>
          </div>
        )}

        {/* Sounds */}
        <audio ref={correctSound} src="https://www.soundjay.com/buttons/sounds/button-4.mp3" />
        <audio ref={wrongSound} src="https://www.soundjay.com/button/beep-05.mp3" />
      </div>
    </div>
  );
}

const styles = {
  body: {
    fontFamily: "'Comic Sans MS', cursive",
    backgroundColor: '#fff8e1',
    textAlign: 'center',
    padding: 30,
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    background: '#ffffff',
    borderRadius: 20,
    padding: 30,
    maxWidth: 600,
    width: '100%',
    margin: 'auto',
    boxShadow: '0 0 15px rgba(0,0,0,0.2)',
  },
  h1: {
    color: '#ff6f00',
    fontSize: '2rem',
  },
  cartoon: {
    width: 180,
    height: 180,
    marginBottom: 10,
    margin: "0 auto",
    objectFit: 'contain',
  },
  input: {
    fontSize: 18,
    padding: 10,
    margin: '0 auto',
    marginTop: 10,
    borderRadius: 10,
    width: 140,
    textAlign: 'center',
    border: '2px solid #ffcc80',
  },
  button: {
    fontSize: 18,
    padding: '10px 25px',
    margin: '20px 0',
    borderRadius: 10,
    backgroundColor: '#ff6f00',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
  stepBox: {
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  feedback: {
    fontWeight: 'bold',
    fontSize: '1.2rem',
    marginTop: 20,
  },
};
